import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Divider,
  IconButton,
  Modal,
  TextField,
  Typography,
} from '@mui/material';
import { SystemConfigData, SystemConfigResource } from '../../resources';
import { useRequester } from '../../hooks';
import { Form } from '../../design';
import { Close as CloseIcon, Save as SaveIcon } from '@mui/icons-material';

interface Props {
  config?: SystemConfigData;
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export default function LLMConfigFormModal({
  config,
  open,
  onClose,
  onSuccess,
}: Props) {
  const saveConfig = useRequester<SystemConfigResource>({
    onSubmit: (data: any) =>
      SystemConfigResource.createOverride(data.key, data.value),
    onSuccess,
    onError: console.log,
  });

  const handleSubmit = (data: any) => {
    if (!config?.key) return;
    saveConfig.submit({ key: config.key, value: data.value });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box className="bg-white absolute top-1/2 left-1/2 w-[600px] transform -translate-x-1/2 -translate-y-1/2 p-8 gap-4 flex flex-col">
        <Box className="flex justify-between">
          <Box className="flex flex-row">
            <Typography variant="h5" sx={{ fontWeight: 500 }}>
              Set an override for {config?.key}
            </Typography>
          </Box>
          <IconButton onClick={onClose} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <Box className="flex" sx={{ mt: -2 }}>
          <Typography
            variant="body2"
            color="error.main"
            sx={{ fontWeight: 600 }}
          >
            CAUTION: Make sure you understand what {config?.key} does before
            setting an override.
          </Typography>
        </Box>

        <Form
          onSubmit={handleSubmit}
          className="flex flex-col gap-4"
          disabled={saveConfig.loading}
        >
          <TextField
            name="value"
            label="Value"
            fullWidth
            size="small"
            defaultValue={config?.value}
          />

          <Divider />
          <Box className="flex flex-row gap-4">
            <Button
              startIcon={
                saveConfig.loading ? (
                  <CircularProgress size={20} />
                ) : (
                  <SaveIcon sx={{ height: 20, width: 20 }} />
                )
              }
              type="submit"
              variant="contained"
              disabled={saveConfig.loading}
            >
              Save
            </Button>
            {saveConfig.error && (
              <Alert severity="error">{saveConfig.error}</Alert>
            )}
          </Box>
        </Form>
      </Box>
    </Modal>
  );
}
